package ru.dinarastepina.fabvocab.web.components

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.px
import ru.dinarastepina.fabvocab.web.theme.Slate400
import ru.dinarastepina.fabvocab.web.theme.Slate500
import ru.dinarastepina.fabvocab.web.theme.Slate700

@Composable
fun EmptyState(
    title: String,
    subtitle: String,
    modifier: Modifier = Modifier,
) {
    Column(
        modifier = modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        Box(
            modifier = Modifier
                .size(64.px)
                .backgroundColor(org.jetbrains.compose.web.css.Color("#F1F5F9"))
                .borderRadius(20.px),
            contentAlignment = Alignment.Center,
        ) {
            SpanText(
                "📖",
                modifier = Modifier.fontSize(28.px),
            )
        }
        SpanText(
            title,
            modifier = Modifier
                .margin(top = 16.px)
                .fontSize(18.px)
                .fontWeight(FontWeight.Bold)
                .color(Slate700),
        )
        SpanText(
            subtitle,
            modifier = Modifier
                .margin(top = 8.px)
                .fontSize(14.px)
                .color(Slate500)
,
        )
    }
}
